export default __webpack_public_path__ + "static/media/person_icon_white_desk.7d1d80af.png";